import React, { useState } from "react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useToast } from "@/hooks/use-toast";

const API_BASE = process.env.REACT_APP_BACKEND_URL;

export function PasswordChangeForm({ authToken, onSuccess }) {
  const { toast } = useToast();
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!authToken) {
      toast({ title: "Nicht eingeloggt", description: "Bitte melde dich erneut an.", variant: "destructive" });
      return;
    }
    if (newPassword !== newPasswordConfirm) {
      toast({ title: "Passwörter stimmen nicht überein", variant: "destructive" });
      return;
    }
    if (newPassword.length < 8) {
      toast({ title: "Passwort zu kurz", description: "Bitte mindestens 8 Zeichen verwenden.", variant: "destructive" });
      return;
    }

    setLoading(true);
    try {
      await axios.post(
        `${API_BASE}/api/auth/change-password`,
        { old_password: oldPassword, new_password: newPassword },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        },
      );
      toast({ title: "Passwort geändert" });
      setOldPassword("");
      setNewPassword("");
      setNewPasswordConfirm("");
      onSuccess && onSuccess();
    } catch (e) {
      console.error(e);
      const msg = e?.response?.data?.detail || "Passwort konnte nicht geändert werden.";
      toast({ title: "Fehler", description: msg, variant: "destructive" });
    } finally {
      setLoading(false);
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-3" data-testid="password-change-form">
      <div className="space-y-1.5">
        <Label htmlFor="old-password">Altes Passwort</Label>
        <Input
          id="old-password"
          type="password"
          value={oldPassword}
          onChange={(e) => setOldPassword(e.target.value)}
          required
          data-testid="password-change-old-input"
        />
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="new-password">Neues Passwort</Label>
        <Input
          id="new-password"
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          required
          data-testid="password-change-new-input"
        />
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="new-password-confirm">Neues Passwort (Wiederholung)</Label>
        <Input
          id="new-password-confirm"
          type="password"
          value={newPasswordConfirm}
          onChange={(e) => setNewPasswordConfirm(e.target.value)}
          required
          data-testid="password-change-confirm-input"
        />
      </div>
      <Button
        type="submit"
        disabled={loading}
        className="mt-1 rounded-full bg-sky-600 px-5 text-sm font-medium text-white hover:bg-sky-500 disabled:opacity-60"
        data-testid="password-change-submit-button"
      >
        {loading ? "Wird gespeichert..." : "Passwort ändern"}
      </Button>
    </form>
  );
}
